import React from "react";
import ReactModal from "react-modal";
import "./custom-sign-modal.scss";
import { UpdateSignatureMember } from "../../../api";
import ReactSignatureCanvas from "react-signature-canvas";

class CustomSignErrorModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.data,
            isSigned: false,
            signUploading: false,
        };
        this.handleAddSignature = this.handleAddSignature.bind(this);
    }
    sigPad = {};
    createSiganture() {
        return Object.keys(this.sigPad).length !== 0 && !this.sigPad.isEmpty()
            ? this.sigPad.getTrimmedCanvas().toDataURL("image/png")
            : "";
    }

    handleAddSignature() {
        let formData = {};
        formData["signature"] = this.createSiganture();
        formData["user_id"] = this.props?.data?.id;
        this.setState({ signUploading: true });
        UpdateSignatureMember(formData)
            .then((response) => {
                if (response.success) {
                    this.setState({ signUploading: false });
                    this.props.closeModal();
                }
            })
            .catch((error) => {
                this.setState({ signUploading: false });
            });
    }

    clear = () => {
        this.sigPad.clear();
        this.setState({
            isSigned: false,
        });
    };

    render() {
        return (
            <ReactModal
                isOpen={this.props.show}
                className="custom-sign-error-modal"
            >
                <div className="modal-header">
                    <h4 className="text-left">Signature</h4>
                </div>
                <div className="modal-sign-wraper">
                    <div>
                        <div className="signature-block">
                            <div className="nav nav-tabs ">
                                <div
                                    eventKey={1}
                                    className={`nav-item nav-link active`}
                                >
                                    <label>
                                        It appears that you do not have a
                                        digital signature on file. Please sign
                                        below to complete the signature process.
                                        These signatures are required for the
                                        eSign process.
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="signaturetabselect">
                            <div
                                className="signature-pad"
                                style={{
                                    border: "1px solid #EAEBEF",
                                }}
                            >
                                <ReactSignatureCanvas
                                    penColor="black"
                                    canvasProps={{
                                        width: 500,
                                        height: 150,
                                        className: "sigCanvas",
                                    }}
                                    ref={(ref) => {
                                        this.sigPad = ref;
                                    }}
                                    onEnd={() =>
                                        this.setState({
                                            isSigned: true,
                                        })
                                    }
                                />
                            </div>
                            <button
                                className="thnks-label"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.clear();
                                }}
                            >
                                Clear Signature
                            </button>
                        </div>
                    </div>
                    <div className="footer">
                        <button
                            className="btn confirm-button addbtnprimary"
                            onClick={() => this.handleAddSignature()}
                            disabled={
                                Object.keys(this.sigPad).length === 0 ||
                                this.sigPad.isEmpty() ||
                                this.state.signUploading
                            }
                        >
                            Add
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default CustomSignErrorModal;
